<script>
import { mapGetters } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';

export default {
  name: 'FullComparisonDialogPrice',
  props: {
    zoomMeetingCategory: {
      type: String,
      default: '',
    },
    isNotAvailable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [discountedMonthPrice],
  computed: {
    ...mapGetters(['planMapFlatRaw', 'getSelectedBasePlanInfo']),
    notVisiblePrice() {
      return this.isNotAvailable;
    },
    isNormalBillingCycle() {
      return [BILLING_CYCLE.ANNUAL, BILLING_CYCLE.MONTHLY].includes(this.getSelectedBasePlanInfo?.plans?.[0]?.billing_cycle);
    },
    currentBillingCycleTip() {
      const regExp = /(\d) (\d)/g;
      const regReplaceVal = '$1\u00A0$2';
      if (this.getSelectedBasePlanInfo?.plans?.[0]?.billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.$t('billing.common.per_billing_cycle_license.price_annual', { price: (this.annualPrice || '').replace(regExp, regReplaceVal) });
      } else {
        return this.$t('billing.common.per_billing_cycle_license.price_monthly', { price: (this.monthlyPrice || '').replace(regExp, regReplaceVal) });
      }
    },
    planAllBillingCycles() {
      return this.planMapFlatRaw.filter((plan) => plan.zoomMeetingCategory === this.zoomMeetingCategory);
    },
    annualPlan() {
      return this.planAllBillingCycles.find(item => item.billing_cycle === BILLING_CYCLE.ANNUAL);
    },
    monthlyPlan() {
      return this.planAllBillingCycles.find(item => item.billing_cycle === BILLING_CYCLE.MONTHLY);
    },
    monthlyPrice() {
      return this.ariaPriceOfMonthForLabel(this.monthlyPlan);
    },
    annualPrice() {
      return this.ariaPriceOfMonthForLabel(this.annualPlan);
    },
  },
};
</script>

<template>
  <div tabindex="-1" style="display: block;" class="opc-dialog-comparison-price" v-if="isNormalBillingCycle">
    <!--    <p class="opc-dialog-comparison-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(annualPlan)">
                          <span
                            v-for="(value, key, index) in getPriceOfMonth(annualPlan.amount, annualPlan.billing_cycle, { forceDiff: true })"
                            :key="index"
                            :class="[`opc-dialog-comparison-price-container__${key}`, useSmallSize(value) ? 'opc-dialog-comparison-price-container__small' : '']"
                            :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                            aria-hidden="true"
                          >
                            {{ value.symbol ? value.symbol : value }}
                          </span>
        </p>
        <p class="opc-dialog-comparison-price-monthly-tip">
          /month/user, billed annually <br/>
          <span class="opc-dialog-comparison-price-monthly">
            or <span class="opc-dialog-comparison-price-monthly_price">{{ monthlyPrice }}</span> billed monthly
          </span>
        </p>-->
    <p class="opc-dialog-comparison-price-current-cycle_price" :style="{opacity:notVisiblePrice?0:1}">
      {{ currentBillingCycleTip }}<priceVATTip />
    </p>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/_variables.scss';
.opc-dialog-comparison-price{
  text-transform: none;
  .opc-dialog-comparison-price-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2px;
    margin: 0 0 4px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);


    &__integer {
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-align: left;
    }

    &__small {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
    }

    &__decimal {
      font-size: 12px;
      font-weight: 600;
      line-height: 14.4px;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-align: left;
    }

    &__currency {
      font-size: 12px;
      font-weight: 600;
      line-height: 14.4px;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-align: left;
    }
  }

  .opc-dialog-comparison-price-monthly-tip, .opc-dialog-comparison-price-monthly {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.4px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }

  .opc-dialog-comparison-price-monthly {
    color: var(--zoom-color-text-strong-neutral, #555B62);
  }
  .opc-dialog-comparison-price-current-cycle_price{
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    word-break: break-word;
  }
}


</style>
